
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`
module.exports = require("../lib-vendor/d3-shape/src/index.js");



//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib/d3-shape.js
// module id = 6906
// module chunks = 0